import { DefaultConfigs, VerifyStatus } from "@/common/js/constant";
import * as request from "@/utils/request";

// 钱包服务域名
const baseUrl = DefaultConfigs.publicAPIPath;

const apiVersion: string = require("@/../package.json").version;

// 获取核验因子
export function query(data: {
  sessionId: string;
  verifySdkVersion: string;
  passportToken: string;
}): Promise<PageRiskDetail> {
  return request
    .post<{ atoDomain: PageRiskDetail }>(`${baseUrl}/risk-api/sofiPassportGetCheckList`, data, {
      params: {
        productName: "",
        interfaceName: "sofi_veryfiList",
        demand: "sofi-veryfiList",
        scene: "GLOBAL_FINANCE_SOFI_VERIFYLIST",
        apiVersion,
      },
    })
    .then((ret) => ret.atoDomain);
}

// 选择核验方式
export function select(data: {
  verifyType: RiskFactor;
  currentVerifyType: RiskFactor;
  sessionId: RiskToken;
  verifySdkVersion: string;
  passportToken: string;
}): Promise<{ status: string; verifyInfo: MethodDetail } & SwitchVerifyDetail> {
  // console.log('========================================')
  // 转换参数
  const params: {
    // 设备号
    // 注：H5非必输
    deviceId: string;
    // 核验SDK版本号
    // 注：H5非必输,1.4版本后必输，经服务端确认已更改为verifySdkVersion
    verifySdkVersion: string;
    // 国家
    // country: string;
    // 核验会话id
    sessionId: RiskToken;
    // 核验类型
    verifyType: RiskFactor;
    // currentVerifyType
    currentVerifyType: RiskFactor;
  } = {
    deviceId: "",
    // country: '',
    verifySdkVersion: data.verifySdkVersion,
    sessionId: data.sessionId,
    verifyType: data.verifyType,
    currentVerifyType: data.currentVerifyType,
  };

  return request
    .post<
      { status: string; verifyInfo: MethodDetail } & SwitchVerifyDetail
    >(`${baseUrl}/sofipo/v0/verify/trigger`, params)
    .then((ret) => {
      // 请求验证码成功状态
      if (ret.status === VerifyStatus.SUCCESS) {
        return ret;
      }
      // 失败
      return Promise.reject(ret);
    });
}

// 提交核验答案
export function answer(data: {
  verifyType: RiskFactor;
  answer: string;
  currentVerifyType: RiskFactor;
  sessionId: RiskToken;
  verifySdkVersion: string;
  passportToken: string;
}): Promise<RiskVerifyResult> {
  // console.log('===========', data);
  // 转换参数
  const { verifySdkVersion, passportToken, ...params } = data;
  // @ts-ignore
  params.verifySdkVersion = verifySdkVersion;
  // @ts-ignore
  // params.deviceId = '';

  // const commonAttrs = getCommonAttrs();
  // @ts-ignore
  // params.uid = commonAttrs.pub_uid;
  return request
    .post<{ token: RiskToken; status: VerifyStatus }>(`${baseUrl}/sofipo/v0/verify/check`, params)
    .then((verify_data) => {
      // 核验成功
      if (verify_data.status === VerifyStatus.SUCCESS) {
        return {
          verify_data: verify_data.token,
          verify_session_id: data.sessionId,
          verifySdkVersion: data.verifySdkVersion,
        };
      }
      // 核验失败
      return Promise.reject(verify_data);
    });
}
